/*
 * Name: Image Card
 * Desc:
 *
 */
import Link from "next/link"
import React, { useState } from "react"
import isJson from "@lib/isJson"
import saveStar from "@images/icons/saveStarPink.svg"
import * as styles from "./ImageCard.module.scss"

const { NEXT_PUBLIC_DOMAIN } = process.env

const ImageCard = ({ image, imigixParams, handleChange, width, selected = false, isMobile }) => {
  const [loaded, setLoaded] = useState(false)

  const ratio = image.height / image.width

  const supplier = isJson(image.author) ? JSON.parse(image.author) : {}

  const otherSupplierslist = image.customData.othersuppliers
    ? JSON.parse(image.customData.othersuppliers)
    : null

  const otherSuppliers =
    otherSupplierslist && otherSupplierslist.length
      ? otherSupplierslist.map((otherSupplier, i) => (
          <React.Fragment key={`${otherSupplier.id}${image.id}`}>
            {i !== 0 ? <span className={styles.sep}>{",  "}</span> : null}
            <span>
              <Link href={`/supplier/${otherSupplier.slug}`}>
                <a>{otherSupplier.name}</a>
              </Link>
            </span>
          </React.Fragment>
        ))
      : null

  return (
    <div
      className={`${styles.ImageCard} ${loaded ? styles.loaded : ""} ${
        selected ? styles.selected : ""
      }`}
      style={{
        height: isMobile ? width * ratio : width * ratio + 5, // get height from ratio and adjust for borders
      }}
      onClick={() => handleChange(image, selected)}
    >
      <div className={styles.inner}>
        <img
          className={styles.img}
          src={`${image.url}${imigixParams}`}
          alt=""
          onLoad={() => setLoaded(true)}
        />
        <img className={styles.star} src={saveStar} />
        {supplier.name ? (
          <div className={styles.info}>
            <span className={styles.name}>
              <Link href={`/supplier/${supplier.slug}`}>
                <a>
                  {supplier.name}
                  {supplier.service ? (
                    <>
                      <span className={styles.nameSep}>|</span>
                      <span className={styles.service}>{supplier.service}</span>
                    </>
                  ) : null}
                </a>
              </Link>
            </span>
            {otherSuppliers}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default ImageCard
